import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProfileState } from '@et/guards';
import { CompanyData } from '@et/typings';
import { Store } from '@ngxs/store';
import { filter, first } from 'rxjs';

export const companyResolver: ResolveFn<CompanyData> = () => {
  return inject(Store)
    .select(ProfileState.getCompany)
    .pipe(filter(Boolean), first());
};
